/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { equal } from '@ember/object/computed';
import AttributeModel from 'cio/models/attribute';
import EventModel from 'cio/models/event';
import { Task } from 'ember-concurrency';

interface DataIndexItemCampaignsArgs {
  item: AttributeModel | EventModel;
  createCampaignTask: Task<unknown, []>;
}

export default class DataIndexItemCampaigns extends Component<DataIndexItemCampaignsArgs> {
  @equal('args.item.type', 'event') canCreateCampaign!: boolean;
}
